/**
 * 股吧签
 */
import React, { useEffect } from "react"
import "./index.less"
import Param from "../../../modules/public_fun/param"
import { PageType } from "../pagetype"

export function GuBa(props: { quotecode: string; pagetype: PageType }) {
  useEffect(() => {
    if (props.quotecode.toLowerCase().startsWith("90.bk")) {
      let gubacode = props.quotecode.replace("90.", "")
      let list = new window.PageList({
        stockcode: gubacode,
        root: "#gb-new",
        isRelease: Param.get("env") == "test" ? false : true,
      })
      list.enter()
    } else {
      let url = "//quote.eastmoney.com/unify/codecenter/" + props.quotecode + ".js"
      let outerCode = props.quotecode.split(".")?.[1] || ""
      if (props.pagetype == PageType.日本 || props.pagetype == PageType.韩国 || props.pagetype == PageType.台湾 || props.pagetype == PageType.法国 || props.pagetype == PageType.德国 || props.pagetype == PageType.马来西亚) {
        outerCode = "cjpl"
      // } 
      // else if (props.pagetype == PageType.韩国) {
      //   outerCode = "krx" + outerCode
      // } else if (props.pagetype == PageType.台湾) {
      //   outerCode = "twse" + outerCode
      // } else if (props.pagetype == PageType.国证指数) {
      //   outerCode = "gz" + outerCode
      } else {
        outerCode = ""
      }
      $.ajax({
        url: url,
        type: "get",
        dataType: "jsonp",
        // jsonp:'callback',
        // jsonpCallback:'innerCodeByUnifyId',
        jsonpCallback: "codecenterget",
        success: function (data) {
          let list = new window.PageList({
            stockcode: String(data?.innerCode ? data.innerCode : outerCode),
            root: "#gb-new",
            isRelease: Param.get("env") == "test" ? false : true,
          })
          list.enter()
        },
        error: function () {},
      })
    }
  }, [])

  return (
    <>
      <div id="gb-new"></div>
    </>
  )
}
